<template>
	<div>
		<el-row>
			<el-col :span="3">
				<el-table :data="tableData" ref="singleTable" highlight-current-row max-height="400px"
					@current-change="currentChangeStore"
					:header-cell-style="{ background: '#efefef', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{'text-align':'center','height':'40px'}" :row-style="{height: '10px'}">
					<el-table-column prop="title" label="门店" @cell-click></el-table-column>
				</el-table>
			</el-col>
			<el-col :span="21" style="padding: 0 20px 0 1px;">
				<el-table v-if="this.detail == false" :data="tableData2"
					:header-cell-style="{ background: '#efefef', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{'text-align':'center'}" v-loading="loading">
					<el-table-column label="门店" width="100">
						<template slot-scope="scope">
							<span>{{scope.row.storeName}}</span>
						</template>
					</el-table-column>
					<el-table-column label="门店属性">
						<template slot-scope="scope">
							<span>{{scope.row.storeType}}</span>
						</template>
					</el-table-column>
					<el-table-column label="物资数量">
						<template slot-scope="scope">
							<span>{{scope.row.materialTypeNum?scope.row.materialTypeNum:0}}</span>
						</template>
					</el-table-column>
					<el-table-column label="最近盘点时间">
						<template slot-scope="scope">
							<span>{{scope.row.addTime}}</span>
						</template>
					</el-table-column>
					<el-table-column label="门店负责人/店长">
						<template slot-scope="scope">
							<span>{{scope.row.name}}</span>
						</template>
					</el-table-column>
					<!-- 	<el-table-column label="图片">
						<template slot-scope="scope">
							<el-image></el-image>
						</template>
					</el-table-column> -->
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="edit(scope.row,scope.$index)">
								查看
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-table v-if="this.detail == true" :data="tableData3"
					:header-cell-style="{ background: '#efefef', 'text-align': 'center', color: '#2D2D2D' }"
					:cell-style="{'text-align':'center'}" v-loading="loading">
					<el-table-column label="门店" width="100">
						<template slot-scope="scope">
							<span>{{scope.row.storeName}}</span>
						</template>
					</el-table-column>
					<el-table-column label="盘点ID" width="100">
						<template slot-scope="scope">
							<span>{{scope.row.applyId}}</span>
						</template>
					</el-table-column>
					<el-table-column label="物资ID">
						<template slot-scope="scope">
							<span>{{scope.row.id}}</span>
						</template>
					</el-table-column>
					<el-table-column label="物资名称">name
						<template slot-scope="scope">
							<span>{{scope.row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="单位">
						<template slot-scope="scope">
							<span>{{scope.row.unit}}</span>
						</template>
					</el-table-column>
					<el-table-column label="库存">
						<template slot-scope="scope">
							<span>{{scope.row.materialTypeNum}}</span>
						</template>
					</el-table-column>
					<el-table-column label="更新时间">
						<template slot-scope="scope">
							<span>{{scope.row.addTime}}</span>
						</template>
					</el-table-column>
					<el-table-column label="物资图片">
						<template slot-scope="scope">
							<el-image style="width:60px" :src="scope.row.picture"> </el-image>
						</template>
					</el-table-column>
				</el-table>
				<!-- <div style="margin: 10px 0 0 20px;">
					<button type="text" style="color: #aaa;border:none;" @click="add01 = true;">+添加</button>
				</div> -->
				<!-- 	<el-dialog :visible.sync="add01" width="50%">
					<template>
					  <div class="dtitle">门店物资>添加物资</div>
					  <div class="right_warp">
						<el-input clearable size="small" style="text-align: left" class="jul" @keydown.enter.native="g" placeholder="请输入物资名称"
							 clearable></el-input>
						<el-button class="jul" type="primary" size="small" @click="">搜索</el-button>
					  </div>
					  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
					  <div style="margin: 15px 0;"></div>
					  <el-checkbox-group v-model="checkedMaterials" @change="handleCheckedMaterialsChange">
					    <el-checkbox style="width: 18%; margin:10px 0 10px 10%;" v-for="material in materials" :label="material" :key="material">{{material}}</el-checkbox>
					  </el-checkbox-group>
					</template>
					<div style="display: flex;justify-content:center;">
						<el-button size="small" @click="add01 = false">取 消</el-button>
						<el-button size="small" type="primary"  @click="add01 = false">确 定</el-button>
					</div>
				</el-dialog> -->
				<div style="display: flex;justify-content:center;">
					<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
						style="margin-top: 30px;" layout="  prev, pager, next, jumper"
						:page-size="[10, 20, 30, 50, 100]" :current-page="query2.page" :total="total">
					</el-pagination>
					<el-button size="small" type="primary" @click="back()" style="margin-top: 30px;">返回</el-button>
				</div>
			</el-col>
		</el-row>
		<div></div>
	</div>
</template>
<script>
	import Vue from 'vue'
	const materialOptions = ['1湿纸巾', '2抽纸', '3围脖', '4风筒', '11湿纸巾', '22抽纸', '33围脖', '44风筒', '111湿纸巾', '222抽纸', '333围脖',
		'444风筒'
	];
	export default {
		data() {
			return {
				add01: false,
				checkAll: false,
				checkedMaterials: [],
				materials: materialOptions,
				isIndeterminate: true,
				tableData: [],
				tableData2: [],
				tableData3: [],
				detail: false,
				storeName: '',
				storeId: '',
				loading: false,
				query: {
					page: 1,
					size: 99,
					total: 0,
				},
				query2: {
					page: 1,
					size: 10,
					total: '',
				},
				total: 0,
				state: '',
				// 要展开的行，数值的元素是row的key值
				expands: [],
				list: [{
					name: '名称',
					num: '数量',
					type: '类型',
					change01: 0
				}],
			}
		},
		mounted() {
			this.getStorelist()
			this.gelist()
		},
		created() {
			this.tableData2 = [{
				name: '',
				num: '',
				type: ''
			}, ]
			this.tableData2.map(i => {
				i.show = false
				return i
			})
		},
		methods: {
			// 获取门店列表
			getStorelist() {
				this.$http.get("store/list?title=" + this.storeName + "&page=" + this.query.page + "&size=" + this.query
					.size + "&state=" + this.state + "&businessType=0").then(function(res) {
					if (res.body.code == "200") {
						this.tableData = res.body.data.rows
						this.query.total = res.body.data.total
					} else {
						this.$message.error("请求失败")
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			back() {
				this.storeId = ""
				this.gelist()
			},
			gelist() {
				this.detail = false
				this.loading = true
				var a = ""
				if (this.storeId != null && this.storeId != "") {
					a = "?storeId=" + this.storeId
				}
				a = a + "?pageNum=" + this.query2.page + "&pageSize=" + this.query2.size
				console.log(a)
				this.$http.get("material/listStoreM" + a).then(res => {
					if (res.body.code == "200") {
						this.tableData2 = res.body.data
						this.tableData2.map(i => {
							i.show = false
							return i
						})
						this.total = res.body.total
						console.log(this.total)
						this.loading = false
					} else {
						this.loading = false
						this.$message.error("系统错误")
					}
				})
			},
			getData(id, storeName, storeId) {
				this.loading = true
				this.$http.get("material/listStoreM" + "?storeId=" + id).then(res => {
					if (res.body.code == "200") {
						this.tableData2 = res.body.data
						this.tableData2.map(i => {
							i.show = false
							return i
						})
						this.loading = false
					} else {
						this.loading = false
						this.$message.error("系统错误")
					}
				})
				this.storeName = storeName
				this.storeId = storeId
			},
			edit(row) {
				this.detail = true
				this.loading = true
				var a = ""
				a = "?pageNum=" + this.query2.page + "&pageSize=" + this.query2.size + "&storeId=" + row.storeId
				this.$http.get("material/storeMList" + a).then(res => {
					if (res.body.code == 200) {
						this.tableData3 = res.body.data
						this.loading = false
					} else {
						this.loading = false
						this.$message.error("系统错误")
					}
				})
			},
			currentChangeStore(val) {
				this.currentRow = val;
				console.log(val)
				this.storeId = val.id
				this.gelist()
			},
			handleCheckAllChange(val) {
				this.checkedMaterials = val ? materialOptions : [];
				this.isIndeterminate = false;
			},
			handleCheckedMaterialsChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.materials.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.materials.length;
			},
			// handleCurrentChange(val) {
			// 	// this.query2.page = val;
			// 	this.gelist()
			// },
			// handleSizeChange(val) {
			// 	// this.query2.size = val;
			// 	this.gelist()
			// },
		}
	}
</script>
<style lang="less" scoped>
	/deep/ .el-table td {
		padding: 0px 0;
		min-width: 0;
		box-sizing: border-box;
		text-overflow: ellipsis;
		vertical-align: middle;
		position: relative;
		text-align: left;
	}

	.demo-table-expand {
		font-size: 0;
	}

	.cell {
		line-height: 40px;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 100%;
	}

	.dtitle {
		font-family: SourceHanSansCN-Bold;
		font-size: 20px;
		margin: 0px 0 20px 0;
	}

	.right_warp {
		display: flex;
		float: right;
		align-items: center;
		font-size: 16px;
		color: #3e3e3e;

		.el-select {
			width: 120px;
		}

		.el-input {
			width: 180px;
		}

		.jul {
			margin-left: 10px;
		}
	}
</style>